import { PaginationProps } from 'components/semantic/PaginationState';
import { Pagination } from 'semantic-ui-react';
import styled from 'styled-components';

// Dimmed and not clickable while results load, as the count and pages may still be those of the previous search
const Bar = styled.div<{ $loading: boolean }>`
  opacity: ${({ $loading }) => ($loading ? 0.45 : 1)};
  pointer-events: ${({ $loading }) => ($loading ? 'none' : 'auto')};
  transition: opacity 0.15s ease;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 1rem;
  margin: 1rem 0;
`;

const Count = styled.div`
  color: rgba(0, 0, 0, 0.6);
`;

interface Props {
  activePage: number;
  /** Total number of matching blocks and how many are shown, or undefined while there is nothing to report */
  count?: { total: number; shown: number };
  loading: boolean;
  onPageChange: (page: number) => void;
  totalPages: number;
}

/** The line between the search and the results: the number of blocks found on the left, pagination on the right. */
export function BlockResultsBar({ activePage, count, loading, onPageChange, totalPages }: Props) {
  return (
    <Bar $loading={loading}>
      <Count>{count && `Found ${count.total} blocks - Showing ${count.shown}`}</Count>
      {totalPages > 0 ? (
        <Pagination
          activePage={activePage}
          totalPages={totalPages}
          onPageChange={(_: any, paginationData: PaginationProps) => {
            onPageChange(Number(paginationData.activePage));
          }}
          firstItem={null}
          lastItem={null}
          pointing
          size="small"
        />
      ) : null}
    </Bar>
  );
}
